import Freelancer from './../../components/freelancer';

const Freelancerpage = () => {

  const token = localStorage.getItem('token') 
  return <Freelancer token={token}/>;
};

export default Freelancerpage;
